module.exports = "<span data-ng-message=required>*A risk type is required</span> ";